<template>
  <main class="product-list">
    <header>
      <p>产品与方案</p>
      <h1>围绕设备场景，<br>提供稳定的硬件基础。</h1>
      <span>主板、工控机、智慧城市终端与服务器产品。</span>
    </header>
    <div class="filters" aria-label="产品筛选">
      <button v-for="filter in filters" :key="filter" type="button" :class="{ active: selectedCategory === filter }" @click="selectedCategory = filter">{{ filter }}</button>
    </div>
    <section v-for="group in filteredGroups" :key="group.name" class="product-group">
      <div class="group-heading"><p>{{ group.name }}</p><span>{{ group.description }}</span></div>
      <div class="product-grid">
        <router-link v-for="product in group.products" :key="product.id" :to="'/product/' + product.id" class="product-card">
          <img :src="imageUrl(product.image)" :alt="product.name">
          <div><p>{{ product.subCategory }}</p><h2>{{ product.name }}</h2><span>查看产品 <b>→</b></span></div>
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
import productCatalog from '@/data/productCatalog'

const productMeta = [
  ['111', 'Atom', '主板', 'x86'], ['112', 'SKY/KBL', '主板', 'x86'], ['113', 'APL', '主板', 'x86'], ['114', 'GML', '主板', 'x86'],
  ['151', 'MB328', '主板', 'ARM'], ['152', 'MB339', '主板', 'ARM'],
  ['121', '4U工控机', '工控机', '工业计算机'], ['122', '视觉工控机', '工控机', '工业计算机'], ['123', '加固工业平板电脑', '工控机', '工业计算机'], ['124', '设备智能工作站', '工控机', '工业计算机'],
  ['131', '智慧城市-井盖/井盖锁', '智慧城市', '城市物联'], ['132', '智慧城市-车位锁', '智慧城市', '城市物联'], ['133', '智慧城市-地磁', '智慧城市', '城市物联'], ['134', '智慧城市-烟感', '智慧城市', '城市物联'], ['135', '智慧城市-路灯', '智慧城市', '城市物联'], ['136', '智慧城市-定位器', '智慧城市', '城市物联'],
  ['141', '服务器', '服务器', '服务器']
]

const groupDescriptions = {
  主板: 'x86 与 ARM 嵌入式主板',
  工控机: '面向工业现场的整机设备',
  智慧城市: '城市物联网感知终端',
  服务器: '高可靠服务器产品'
}

export default {
  name: 'ProductList',
  data () {
    return { selectedCategory: '全部', filters: ['全部', '主板', '工控机', '智慧城市', '服务器'] }
  },
  computed: {
    products () {
      return productMeta.map(([id, name, category, subCategory]) => ({
        id,
        name,
        category,
        subCategory,
        image: productCatalog['image_' + id]
      }))
    },
    filteredGroups () {
      const categories = this.selectedCategory === '全部' ? this.filters.slice(1) : [this.selectedCategory]
      return categories.map(name => ({ name, description: groupDescriptions[name], products: this.products.filter(product => product.category === name) }))
    }
  },
  methods: {
    imageUrl (image) {
      const source = Array.isArray(image) ? image[0] : image
      return source.indexOf('static/') === 0 ? '/' + source : '/static/' + source
    }
  }
}
</script>

<style lang="scss" scoped>
.product-list { min-height: 100vh; padding: 148px 6vw 96px; background: #f4f6f4; color: #111719; }.product-list header { max-width: 760px; margin-bottom: 42px; }.product-list header p, .product-card p, .group-heading p { color: #a65c39; font-family: 'IBM Plex Mono', monospace; font-size: 11px; letter-spacing: .12em; }.product-list h1 { margin: 0 0 22px; font-size: clamp(44px, 5vw, 72px); line-height: 1.1; letter-spacing: -.065em; }.product-list header span { color: #536063; font-size: 17px; }.filters { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 78px; }.filters button { padding: 10px 16px; border: 1px solid #c9d0ce; color: #465154; background: transparent; cursor: pointer; font: inherit; font-size: 14px; transition: .2s ease; }.filters button:hover, .filters button.active { border-color: #c76b3a; color: #fff; background: #c76b3a; }.product-group { display: block; margin-top: 72px; }.product-group:first-of-type { margin-top: 0; }.group-heading { display: flex; align-items: baseline; justify-content: space-between; gap: 20px; margin-bottom: 22px; padding-bottom: 17px; border-bottom: 1px solid #bdc5c2; }.group-heading p { margin: 0; }.group-heading span { color: #536063; font-size: 14px; }.product-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }.product-card { min-height: 430px; overflow: hidden; background: #fff; }.product-card img { display: block; width: 100%; height: 270px; object-fit: cover; transition: transform .5s ease; }.product-card:hover img { transform: scale(1.03); }.product-card div { padding: 23px 24px 26px; }.product-card p { margin: 0 0 9px; }.product-card h2 { margin: 0 0 18px; font-size: 27px; letter-spacing: -.04em; }.product-card span { font-size: 14px; font-weight: 600; }.product-card b { margin-left: 8px; color: #c76b3a; } @media (max-width: 900px) { .product-grid { grid-template-columns: repeat(2, 1fr); } } @media (max-width: 560px) { .product-list { padding: 120px 16px 56px; }.product-grid { grid-template-columns: 1fr; }.product-list header { margin-bottom: 38px; }.product-list h1 { font-size: 46px; }.filters { margin-bottom: 52px; }.product-group { margin-top: 52px; }.group-heading { display: block; }.group-heading span { display: block; margin-top: 8px; } }
</style>
